var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMessenger = function SvgIconMessenger(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.2380952,9.52380952 L40.4761905,9.52380952 L40.4761905,30.952381 L9.52380952,30.952381 L9.52380952,35.7142857 C9.52380952,37.0238095 10.5952381,38.0952381 11.9047619,38.0952381 L38.0952381,38.0952381 L47.6190476,47.6190476 L47.6190476,11.9047619 C47.6190476,10.5952381 46.547619,9.52380952 45.2380952,9.52380952 L45.2380952,9.52380952 Z M35.7142857,23.8095238 L35.7142857,2.38095238 C35.7142857,1.07142857 34.6428571,0 33.3333333,0 L2.38095238,0 C1.07142857,0 0,1.07142857 0,2.38095238 L0,35.7142857 L9.52380952,26.1904762 L33.3333333,26.1904762 C34.6428571,26.1904762 35.7142857,25.1190476 35.7142857,23.8095238 L35.7142857,23.8095238 Z",
    id: "path-msg"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_forum"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-msg"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-msg"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMessenger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-messenger.3f8d77bd69053514f6d41cd11f73266b.svg";